export class MessageDTO {
    id?: number;
    dateTime?: string;
    title = "";
    body = "";
    read = false;
}

export default class Message extends MessageDTO {
    constructor(dto?: MessageDTO) {
        super();
        if (dto) {
            Object.assign(this, dto);
        }
    }
}